import React from 'react';
import { CloseIcon, ArrowRightWhiteIcon } from '../icons';

interface SentMessageModalProps {
    isOpen: boolean;
    onClose: () => void;
    onGoToInbox: () => void;
}

export const SentMessageModal: React.FC<SentMessageModalProps> = ({ isOpen, onClose, onGoToInbox }) => {
    if (!isOpen) return null;

    const handleGoToInbox = () => {
        onGoToInbox();
        onClose();
    }

    return (
        <div className="fixed inset-0 w-full h-full flex justify-center items-center bg-black/70 backdrop-blur-sm z-50 p-4 font-grotesk">
            <div className="relative w-[538px] bg-white rounded-2xl flex flex-col items-center">
                <div className="absolute top-0 right-0 pt-6 pr-6">
                    <button onClick={onClose} className="flex p-2.5 justify-center items-center gap-2 rounded-full bg-grayscale-1200 shadow-custom-light">
                        <CloseIcon />
                    </button>
                 </div>

                 <div className="p-6 w-full flex flex-col gap-4">
                    <h2 className="text-grayscale-1300 font-grotesk text-base font-medium">Email Sent!</h2>
                    <p className="text-grayscale-1300 font-grotesk text-sm leading-6">
                        The university will contact you in a short while. Track your conversations under the Inbox tab.
                    </p>
                    <button onClick={handleGoToInbox} className="flex py-2.5 px-4 justify-center items-center gap-2 self-stretch rounded-full bg-primary-500 shadow-custom-light">
                        <span className="text-white text-center font-grotesk text-sm font-medium">Go to Inbox</span>
                        <ArrowRightWhiteIcon />
                    </button>
                 </div>
            </div>
        </div>
    );
};